import * as React from 'react'
import { Inputs } from 'react-use-form-state'

import { LabelText } from '..'

interface ILabel<T> {
  input: Inputs<T>
  name: keyof T
  children: React.ReactNode
  className?: string
}

export default function Label<T>({ input, name, children, className }: ILabel<T>) {
  if (typeof name !== 'string') {
    throw new TypeError('name must be a string')
  }

  return (
    <label {...input.label(name)} className={className}>
      <LabelText>{children}</LabelText>
    </label>
  )
}
